import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { AddIcon } from '@systemeio/ui'

interface ContactFilterAddButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
}

const ContactFilterAddButton = ({ onClick }: ContactFilterAddButtonProps) => {
  const { t } = useLocoTranslation()
  return (
    <button
      type={'button'}
      onClick={onClick}
      className={
        'focus-visible:border-green border-text-secondary/30 text-green hover:border-green main-transition-colors relative flex min-h-[42px] items-center justify-center gap-2 rounded-lg border border-dashed px-4 py-2.5 text-sm font-medium outline-hidden'
      }
    >
      <AddIcon className={'fill-green'} />
      {t('dashboard.contacts.filter.add_condition')}
    </button>
  )
}

export default ContactFilterAddButton
